import React from 'react';
import { usePagination, DOTS } from './usePagination';
import { useAppDispatch, useAppSelector } from '../redux/hooks'

const Pagination = props => {
  
    const { onPageChange, totalCount, siblingCount, currentPage, pageSize } = props;
    const paginationRange = usePagination({ currentPage, totalCount, siblingCount, pageSize });

    if (currentPage === 0 || paginationRange.length < 2) {
        return null;
    }


    const onNext = (disabled: boolean = false) => {
        if (disabled) return;

        onPageChange(currentPage + 1);
    };

    const onPrevious = (disabled: boolean = false) => {
        if (disabled) return;
     
        onPageChange(currentPage - 1);
    };

    const handlePageChange = (pageNumber) => {

        onPageChange(pageNumber)
    }

  
    let dotsCount = 0;

    let lastPage = paginationRange[paginationRange.length - 1];




    return (
        <ul className="filter-block-pagination-container space-top-xl">
            {/* Left navigation arrow */}
            <li>
                <button
                    type='button'
                    className={`filter-block-pagination-button filter-block-pagination-item un-button pagination-button-left ${(currentPage === 1 ? 'disabled' : '')}`}
                    onClick={() => onPrevious(currentPage === 1)}
                    disabled={currentPage === 1}>

                    <svg className="svg-icon" aria-hidden="true">
                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#arrow-left" />
                    </svg>
                    <span className="visually-hidden">Previous</span>
                </button>
            </li>
            {paginationRange.map(pageNumber => {

                if (pageNumber === DOTS) {
                    return <li key={pageNumber + ++dotsCount} className="pagination-item dots">&#8230;</li>;
                }

                // Pages
                return (
                    <li key={pageNumber}>
                        <button
                            type='button'
                            className={`filter-block-pagination-item un-button ${(pageNumber === currentPage ? 'selected' : '')}`}
                            onClick={() => handlePageChange(pageNumber)}>
                            {pageNumber}
                        </button>
                    </li>
                );
            })}
            {/*  Right Navigation arrow */}
            <li>
                <button
                    type='button'
                    className={`filter-block-pagination-button filter-block-pagination-item un-button pagination-button-right ${(currentPage === lastPage ? 'disabled' : '')}`}
                    onClick={() => onNext(currentPage === lastPage)}
                    disabled={currentPage === lastPage}>
                    <span className="visually-hidden">Next</span>
                    <svg className="svg-icon" aria-hidden="true">
                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#arrow-right" />
                    </svg>
                </button>
            </li>
        </ul>
    );
};

export default Pagination;
